import constant_amortization_repayment_image from '../../../assets/images/components/repaymentInfo/constant_amortization.svg';
import constant_repayment_image from '../../../assets/images/components/repaymentInfo/constant.svg';
import bullet_repayment_image from '../../../assets/images/components/repaymentInfo/bullet.svg';

const RepaymentData = [
  {
    id: '1',
    title: `원리금 균등 분할이란?\n매달 원금 + 이자금액을 일정하게!`,
    image: constant_amortization_repayment_image,
  },
  {
    id: '2',
    title: `원금 균등 분할이란?\n매달 원금은 그대로 이자는 낮아지게!`,
    image: constant_repayment_image,
  },
  {
    id: '3',
    title: `만기 일시 상환이란?\n이자를 먼저 납부하고 원금은 그 후에!`,
    image: bullet_repayment_image,
  },
];

export default RepaymentData;
